import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {AbstractCRUD, CRUDService, ExceptionService, UtilsService} from '../../xform-compat';
import {MindMapVersionNode} from '../../shared/models/mindMapVersionNode.model';
import {catchError, map} from 'rxjs/operators';
import {Company} from '../../shared/models/company.model';
import {Product} from '../../shared/models/product.model';


@Injectable({
  providedIn: 'root'
})
export class MindMapVersionNodeService extends AbstractCRUD<MindMapVersionNode> implements CRUDService<MindMapVersionNode> {

  constructor(
    exceptionService: ExceptionService,
    http: HttpClient,
    utilsService: UtilsService
  ) {
    super(exceptionService, http, utilsService);
  }

  public getResourcePath() {
    return '/map/service/mindmapversionnode';
  }

  public getAllNoPagination(mapsManagerVersionId: number) {
    const params = new HttpParams().set('mapsManagerVersionId', String(mapsManagerVersionId));
    return super.getHTTP().get(this.getAllNoPaginationPath(), {params: params})
      .pipe(catchError(ex => super.getException().catchBadResponse(ex)));
  }

  public updateOrDelete(mindMapVersionId: number, mindMapVersionNodes: Array<MindMapVersionNode>) {
    return super.getHTTP().put(this.getApiPath() + `/${mindMapVersionId}`, mindMapVersionNodes);
  }

  public archive(mindMapVersionId: number, mindMapVersionNodes: Array<MindMapVersionNode>) {
    return super.getHTTP().put(this.getApiPath() + `/archive/${mindMapVersionId}`, mindMapVersionNodes)
      .pipe(catchError(ex => super.getException().catchBadResponse(ex)));
  }

  public createNewMindMapVersionNode(mapsManagerVersionId: number) {
    return super.getHTTP().post(`${this.getApiPath()}/new`, {mapsManagerVersionId: mapsManagerVersionId})
      .pipe(catchError(ex => super.getException().catchBadResponse(ex)));
  }

  public updateSingleNode(mindMapVersionNode: MindMapVersionNode) {
    return super.getHTTP().post(`${this.getApiPath()}/save`, mindMapVersionNode);
  }

  public bindNodeData(node: any,
                      companyProductPairs: Array<{ companies: Array<Company>, products: Array<Product> }>,
                      dataLabel: string,
                      milestones: any,
                      milestoneLabel: string) {
    const body = {
      node: node,
      companyProductPairs: companyProductPairs,
      dataLabel: dataLabel,
      milestoneValues: milestones,
      milestoneLabel: milestoneLabel
    };
    return this.getHTTP().post(`${this.getApiPath()}/bindNode`, body)
        .pipe(catchError(ex => super.getException().catchBadResponse(ex)));
  }

  public generateEndNodes(mapId: number, productEdmGuids: Array<string>) {
    return this.getHTTP().post(`${this.getApiPath()}/generateEndNodes/${mapId}`, productEdmGuids)
        .pipe(catchError(ex => super.getException().catchBadResponse(ex)));
  }

  private getAllNoPaginationPath() {
    return super.getApiPath().concat('/all/noPagination');
  }
}
